import { BaseModel, type RelationConfig } from './base';

// Enums

export enum DemoStatusType {
  error = 1,
  building = 2,
  complete = 3,
}

export const DemoStatusTypeLabels: Record<DemoStatusType, string> = {
  [DemoStatusType.error]: 'general.error',
  [DemoStatusType.building]: 'pages.demo.index.building',
  [DemoStatusType.complete]: 'general.complete',
};

// Helper Classes

export class DemoType extends BaseModel {}

export class DemoStatus extends BaseModel {
  status!: DemoStatusType;

  get isStatusTypeError(): boolean {
    return this.status === DemoStatusType.error;
  }

  get isStatusTypeBuilding(): boolean {
    return this.status === DemoStatusType.building;
  }

  get isStatusTypeComplete(): boolean {
    return this.status === DemoStatusType.complete;
  }
}

// Main Model

export class Demo extends BaseModel {
  idLocation!: number;

  override objectID(): string | null {
    return this.idLocation?.toString() ?? null;
  }
}
